import { ExchangedMonetaryValueBackend, MonetaryValueBackend } from '@luminovo/api-contracts';
import { assertUnreachable, Comparable, compareByNumber } from '@luminovo/commons';

/**
 * Compares items in ASCENDING order by their monetary value.
 *
 * In case the monetary value is not present, the item is sorted to the beginning of the list.
 */
export function compareByMonetaryValue<T>(
    extractMonetaryValue: (item: T) => MonetaryValueBackend | ExchangedMonetaryValueBackend | null | undefined,
): Comparable<T> {
    return compareByNumber((item) => {
        const monetaryValue = extractMonetaryValue(item);
        return normalizeMonetaryValue(monetaryValue);
    });
}

function normalizeMonetaryValue(
    monetaryValue: MonetaryValueBackend | ExchangedMonetaryValueBackend | null | undefined,
) {
    if (monetaryValue === null || monetaryValue === undefined) {
        return -Infinity;
    }

    if ('converted_mv' in monetaryValue) {
        return Number(monetaryValue.converted_mv.amount);
    }

    if ('amount' in monetaryValue) {
        return Number(monetaryValue.amount);
    }

    assertUnreachable(monetaryValue);
}
